<template>
  <div>
    <b-button :class="propBtnTitle === 'Editar dados de pagamento' ?
                'btn btn-editar border-0 font-weight-bold pr-4 pl-4' : 'btn btn-editar-concluidos border-0 font-weight-bold pr-4 pl-4'"
              @click="showModal(propPedido)">
      {{ propBtnTitle }}
    </b-button>
    <b-modal :id="`editar-${propPedido.cx_pedido_id}`"
             centered
             size="xl"
             title="Informações sobre pagamento"
             header-bg-variant="secondary"
             header-text-variant="white"
             no-close-on-backdrop
             hide-header-close>
      <div class="container">
        <div v-for="(parcela, index) in pedido.parcelas"
             :key="index"
             class="parcela">
          <div class="row">
            <label class="mt-4 mb-2 col-12">
              Valor recebido
            </label>
            <input v-model="parcela.valor"
                   v-money="money"
                   class="valor-recebido ml-3 col-2 pt-2 pb-2"
                   maxlength="16"
                   size="sm"
                   @change="calculaRecebido">
            <div class="form-check form-check-inline col-9">
              <b-radio-group :id="`tipo_lancameno_${Math.random()}`"
                             v-model="parcela.forma_pg"
                             class="ml-3"
                             :options="tipoPagamento"
                             value-field="item"
                             text-field="name" />
            </div>
            <div v-if="pedido.parcelas.length > 1"
                 class="align-self-lg-center"
                 @click="excluirPagamento(index, parcela)">
              <icon-svg icon="trash"
                        class="icons--red icon--sm" />
            </div> 
          </div>
        </div>
        <b-button v-if="pedido.parcelas.length <= 2"
                  id="addItens"
                  v-b-modal.modal-1
                  class="mt-4 p-2 pl-3 pr-3 w-100"
                  variant="outline-primary"
                  @click="addParcela">
          <IconSvg class="icon-add-new"
                   icon="add" />
          Adicionar valor e forma de pagamento
        </b-button> 
        <div class="pagamento">
          <div class="pagamento-entrada">
            <span>Total</span>
            <span class="pagamento-valor">
              <input v-money="money"
                     :value="pedido.ordemServico ? pedido.ordemServico.valor_total :
                       pedido.lancamentosAvulso ? pedido.lancamentosAvulso.valor_total: ''"
                     class="text-right"
                     disabled
                     @click="showInfos(item)">
            </span>
          </div>
        </div>
      </div>

      <template v-slot:modal-footer="{ close }">
        <button type="button"
                class="btn btn-close-modal"
                @click="() =>{
                  hideModal(propPedido)
                }">
          Voltar
        </button>
        <button v-if="propPedido.ordemServico"
                type="button"
                class="btn btn-secondary"
                @click="openOs">
          Editar O.S
        </button>
        <NovoLancamento v-if="propPedido.lancamentosAvulso"
                        :prop-pedido="propPedido" />
        <button type="button"
                class="btn btn-secondary"
                :disabled="btnSalvar"
                @click="salvarPagamento">
          Salvar pagamento
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>

  // Importes
  import { VMoney } from 'v-money'
  import pagamentoService from '../pagamentoService'

  // Components
  import NovoLancamento from './NovoLancamento.vue'

  // Services
  import pedidoService from '../pedidoService'

  export default ({
    name: 'EditarPagamento',
    directives: {
      money: VMoney
    },
    components: {
      NovoLancamento
    },
    props: {
      propPedido: {type: Object, default: null},
      propBtnTitle: {type: String, default: 'Editar'}
    },
    data () {
      return {
        pedido: null,
        pagamento: {
          tipo: "A vista",
          id_pedido: this.propPedido.cx_pedido_id,
          valor_total: 0,
          itens: []
        },
        valorRecebido: 'R$ 0,00',
        tipoPagamento: [
          {item: "Dinheiro", name: "Dinheiro"},
          {item: "Cartão de Crédito", name: "Cartão de Crédito"},
          {item: "Cartão de Debito", name: "Cartão de Debito"},
          {item: "Pix", name: "PIX"},
          {item: "Cheque", name: "Cheque"},
          {item: "Outros", name: "Outros"},     
        ],
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
        btnSalvar: false
      }
    },
    watch: {
      propPedido () {
        if (this.propPedido != null) {
          this.pedido = this.propPedido
          // Adiciona uma nova propriedade que guadará possiveis parcelas para semrem excluidas
          this.pedido.pagamentosExcluidos = []
        }
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.pedido = this.propPedido
        // Adiciona uma nova propriedade que guadará possiveis parcelas para semrem excluidas
        this.pedido.pagamentosExcluidos = []

        // // fixa valor total do pedido
        // const valorPedido = this.propPedido.ordemServico ? this.propPedido.ordemServico.valor_total :
        //   this.propPedido.lancamentosAvulso ? this.propPedido.lancamentosAvulso.valor_total : ''
        // this.pedido.valor_total = valorPedido 
      },
      async salvarPagamento () {
        this.btnSalvar = true
        const validacao = this.validacaoForm()
        if (validacao) return displayMessage('error', validacao.msg)

        try {
          loader({text: 'Salvando pagamento', active: true})

          await pagamentoService.updatePagamento(this.pedido)
          this.hideModal(this.propPedido)
          // Renderiza pedidos atualizados
          this.$store.dispatch('frenteCaixa/atualizarPedidos')
          displayMessage('success', 'Pagamento atualizado com sucesso')

        } catch (error) {
          const message = getErrors(error)
          displayMessage('error', 'Erro!', message.message)

        } finally {
          this.btnSalvar = false
          loader({active: false, text: null})
        }
      },
      validacaoForm () {

        // Atualiza valor recebido
        this.calculaRecebido()        

        const formaPg = this.pedido.parcelas.find(item => item.forma_pg === null)
        const pagamentoZerado = this.pedido.parcelas.find(item => item.valor === 'R$ 0,00')

        if (pagamentoZerado) {
          let existeErro = {
            msg: '',
            erro: false,
          }
          existeErro.msg = 'Exclua valores zerados antes de salvar'
          existeErro.erro = true
          this.btnSalvar = false
          return existeErro
        }

        if (formaPg) {
          let existeErro = {
            msg: '',
            erro: false,
          }
          existeErro.msg = 'Defina a forma de pagamento antes de continuar'
          existeErro.erro = true
          this.btnSalvar = false
          return existeErro
        }

        if (this.valorRecebido != this.pedido.valorTotal) {
          
          let existeErro = {
            msg: '',
            erro: false,
          }
          existeErro.msg = 'O valor recebido deve ser igual ao valor do pedido'
          existeErro.erro = true
          this.btnSalvar = false
          return existeErro
        }
      },
      showModal (item) {
        this.$emit('close-modal', item)
        this.$bvModal.show(`editar-${item.cx_pedido_id}`)
      },
      hideModal (item) {
        this.$bvModal.hide(`editar-${item.cx_pedido_id}`)
      },
      addParcela () {
        this.pedido.parcelas.push({
          valor: 'R$ 0,00',
          forma_pg: null,
        })
      },
      calculaRecebido () {
        let valorTotal = 0
        this.pedido.parcelas.forEach(item => {
          const result = item.valor ?  item.valor.replace(/\.|,|R/g, '').replace('$', '').trim() : 0
          valorTotal += Number(result)
        })
        this.valorRecebido = valorTotal
      },
      excluirPagamento (index, parcela) {
        // guarda id da parcela para ser exlucida no server
        if (parcela.cx_pagamento_id) this.pedido.pagamentosExcluidos.push(parcela.cx_pagamento_id)
        //Remove parcela do front
        this.pedido.parcelas.splice(index, 1)
      },
      openOs () {
        this.$router.push({ name: 'ordem_servico_editar', params: { id: this.propPedido.ordemServico.ordem_servico_id } })
      },
    },  
  })

</script>

<style scope>
.icon-add-new {
    fill: #1c7af5;
    width: 20px;
    height: 20px;
    transition: fill 0.2s;
    margin-right: 10px;
  }
  #addItens:hover .icon-add-new {
    fill: white;
  }
  .btn-close-modal {
    background-color: #C7C7C7;
    color: black;
    border: none;
  }
  .btn-close-modal:hover {
    background-color: #C7C7C7;
    color: black;
    border: none;
  }
  .parcela {

    padding-bottom: 1rem;
    border-bottom: solid 1px #C7C7C7;
  }
  .parcelas-title {
    font-size: 18px;
  }
  .valor-recebido {
    outline: none;
  }
  .pagamento {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    margin-top: 30px;
    font-size: 20px;
    font-weight: bold;

  }
  .pagamento-entrada {
    display: flex;
    justify-content: space-between;
    background-color: #C7C7C7;
    padding: 10px;
    min-width: 450px;
  }
  .pagamento-troco {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    min-width: 450px;
  }
  .pagamento-valor {
    font-size: 24px;
  }
  .btn-receber {
    background-color: #1A5E38;
    width: 100%;
  }
  .btn-receber-mensalista {
    width: 100%;
  }
  .btn-editar {
    font-size:1.2rem;
  }
 .btn-editar-concluidos {
    background-color:#bcbcbc !important;
    font-size:1.2rem;
    color:black;
 }
</style>